/* eslint-disable prefer-const */
import React, { useState, useEffect } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import { useT } from 'talkr';
import TextSlider from './textSlider/textSlider';
import logo from './img/logo.png';
import SliderReview from './sliderReview/sliderReview';
import store from '../../../store';
import './styles.scss';
import styles from './loader.module.scss';
import GradientSVG from './gradientSVG';
import steps from '../../../survey/steps';

function LoaderV2() {
  const { T } = useT();
  let [loaderValue, setLoaderValue] = useState(0);
  const idCSS = 'hello';
  const { currentStep } = store.getState().steps;

  function forwardToNextPage() {
    steps.navigate.forward({
      preventAction: 500,
    });
  }
 
  useEffect(() => {
    if (currentStep === 'customV1_loader') {
      const interval = setInterval(() => {
        setLoaderValue(++loaderValue);

        if (loaderValue >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            forwardToNextPage();
          }, 400);
        }
      }, 90);
      return () => {
        clearInterval(interval);
      };
    }
  }, [currentStep]);

  return (
    <div className={`${styles.container}`}>
      <img className={styles.logo} src={logo} alt="logo" />
      <div className={styles.wrapper}>
        <GradientSVG />
        <div className={styles.containerСircle}>
          <CircularProgressbar
            className={styles.loader}
            value={loaderValue}
            maxValue={100}
            text={`${loaderValue}%`}
            strokeWidth={10}
            background
            backgroundPadding={2}
            styles={{
              path: { stroke: `url(#${idCSS})`, height: '100%' },
              background: { fill: '#FFF' },
              trail: { stroke: 'rgba(159, 113, 235, 0.2)' },
              text: { fill: '#303030' },
            }}
          />
        </div>
        <TextSlider />
        <div className={styles.aboutLoaderDescription}>
          {T('loader_slider_description')}
        </div>
        <SliderReview />
      </div>
    </div>
  );
}

export default LoaderV2;
